

export const GO_PLANNER_DOM = document.getElementById('go-planner-page');

export const API_LINK = GO_PLANNER_DOM ? GO_PLANNER_DOM.dataset.link : '';

export const SETTINGS = GO_PLANNER_DOM ? GO_PLANNER_DOM.dataset.settings : '';

export const GENDER_OPTIONS = [
    { id: 'Male', title: 'Male' },
    { id: 'Female', title: 'Female' },
];

export const AGE_GROUP_OPTIONS = [
    { id: 'Age15To24', title: '15-24' },
    { id: 'Age25To54', title: '25-54' },
    { id: 'Age55Plus', title: '55+' },
];

export const LOCATION_OPTIONS = [
    
    { id: 'CarDealership', title: 'Car Dealership'},
    { id: 'DIYHardware', title: 'DIY Hardware'},
    { id: 'RealEstate', title: 'Real Estate'},
    { id: 'Restaurants', title: 'Restaurants'},
    { id: 'TravelAgents', title: 'Travel Agents'},
    { id: 'TyresAndServicing', title: 'Tyres & Servicing'},


    //{ id: 'BigBoxRetailer', title: 'Big Box Retailer'},
    // { id: 'Department', title: 'Department Store'},
    // { id: 'Electronics', title: 'Electronics Store'},
    // { id: 'Hardware', title: 'DIY Hardware'},
    // { id: 'OfficeSupplies', title: 'Office Supplies'},
    // { id: 'OutdoorsStore', title: 'Outdoors Store'},
    // { id: 'PetrolStation', title: 'Petrol Station'},
    // { id: 'QuickService', title: 'QSR'}, 
    // { id: 'Supermarket', title: 'Supermarket'},
    // { id: 'TelcoStore', title: 'Telco Store'},
    // { id: 'TravelAgents', title: 'Travel Agent'},
    // { id: 'Homewares', title: 'Homewares'},
];
